import React from 'react'
import mobileImg from '../../assets/png/Group 64.png'

export default function Mobile() {
    return (
        <div className="mobile">
            <img src={mobileImg} alt=""/>
            <p>For better viewing experience Try the Habhab mindset on a desktop browser</p>
        </div>
    )
}
